import { render, staticRenderFns } from "./GContactButton.vue?vue&type=template&id=8a6821f2&scoped=true&"
import script from "./GContactButton.vue?vue&type=script&lang=ts&"
export * from "./GContactButton.vue?vue&type=script&lang=ts&"
import style0 from "./GContactButton.vue?vue&type=style&index=0&id=8a6821f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6821f2",
  null
  
)

export default component.exports